import { useId } from "react";
import { motion } from "motion/react";
import { Icon } from "./Icon";
import { cx } from "./kit";
import { THEME_OPTIONS, setThemePref, useThemePref } from "../lib/theme";

/** Scelta del tema a tre opzioni; la pillola scorre sull'opzione attiva. */
export function ThemePicker({ compact }: { compact?: boolean }) {
  const pref = useThemePref();
  const pill = useId();
  return (
    <div role="radiogroup" aria-label="Tema" className={cx("inline-flex rounded-lg border border-line bg-ground p-0.5", compact && "w-full")}>
      {THEME_OPTIONS.map((o) => {
        const on = pref === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={on}
            aria-label={compact ? o.label : undefined}
            title={compact ? o.label : undefined}
            onClick={() => setThemePref(o.value)}
            className={cx("relative h-[30px] rounded-md text-[13px] cursor-pointer flex items-center justify-center gap-1.5", compact ? "flex-1" : "px-3", on ? "text-ink font-medium" : "text-muted hover:text-ink")}
          >
            {on && <motion.span layoutId={pill} className="absolute inset-0 rounded-md bg-surface border border-line shadow-sm" transition={{ type: "spring", stiffness: 500, damping: 38 }} />}
            <span className="relative flex items-center gap-1.5">
              <Icon name={o.icon} size={15} />
              {!compact && o.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
